module.exports = __webpack_public_path__ + "img/sessions.1adcc178.svg";